import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../lib/firebase";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { HiEye, HiEyeOff } from "react-icons/hi";

const Signup = () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "The Only Consultant > Signup";
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const userCredential = await createUserWithEmailAndPassword(
                auth,
                formData.email,
                formData.password
            );

            await updateProfile(userCredential.user, {
                displayName: `${formData.firstName} ${formData.lastName}`,
            });

            console.log("Signup successful");
            navigate("/");
        } catch (err) {
            console.error("Signup Error:", err);
            setError(err.message || "An error occurred during signup.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-200 p-4">
            <div className="w-full max-w-full sm:max-w-[350px] bg-[#f3ebe3] rounded-md shadow-xl border border-gray-300 overflow-hidden">
                <div className="w-full flex items-center justify-center px-3 pt-4 sm:pt-6">
                    <h2 className="font-semibold text-center text-base sm:text-lg md:text-[20px] tracking-wide text-gray-800">
                        CREATE ACCOUNT
                    </h2>
                </div>

                <div className="p-4 sm:p-6 md:p-8 flex flex-col space-y-4 sm:space-y-6">
                    {error && (
                        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded text-xs text-center">
                            {error}
                        </div>
                    )}
                    <form className="space-y-4" onSubmit={handleSubmit}>
                        <div className="flex gap-3">
                            <div className="flex-1">
                                <label className="text-xs font-bold mb-1 block text-gray-600 uppercase tracking-wider">
                                    First Name
                                </label>
                                <input
                                    type="text"
                                    name="firstName"
                                    required
                                    placeholder="Jane"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    className="w-full border border-gray-300 bg-white rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#f7adc4] outline-none transition-all"
                                    disabled={loading}
                                />
                            </div>
                            <div className="flex-1">
                                <label className="text-xs font-bold mb-1 block text-gray-600 uppercase tracking-wider">
                                    Last Name
                                </label>
                                <input
                                    type="text"
                                    name="lastName"
                                    required
                                    placeholder="Doe"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    className="w-full border border-gray-300 bg-white rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#f7adc4] outline-none transition-all"
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        <div>
                            <label className="text-xs font-bold mb-1 block text-gray-600 uppercase tracking-wider">
                                Email Address
                            </label>
                            <input
                                type="email"
                                name="email"
                                required
                                placeholder="hello@example.com"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full border border-gray-300 bg-white rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#f7adc4] outline-none transition-all"
                                disabled={loading}
                            />
                        </div>

                        <div>
                            <label className="text-xs font-bold mb-1 block text-gray-600 uppercase tracking-wider">
                                Password
                            </label>
                            <div className="relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    required
                                    placeholder="••••••••"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="w-full border border-gray-300 bg-white rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#f7adc4] outline-none transition-all pr-10"
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#f7adc4] focus:outline-none"
                                >
                                    {showPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />}
                                </button>
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className={`w-full bg-[#f7adc4] text-white tracking-widest rounded-full text-sm font-bold py-3 mt-4 hover:bg-[#f49fb8] transition-all transform active:scale-[0.98] shadow-md ${loading ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                        >
                            {loading ? "CREATING ACCOUNT..." : "SIGN UP"}
                        </button>
                    </form>

                    <div className="text-center">
                        <p className="text-xs text-gray-600">
                            Already have an account?{" "}
                            <Link
                                to="/"
                                className="font-bold text-[#f7adc4] hover:text-[#f49fb8] transition-colors"
                            >
                                Login
                            </Link>
                        </p>
                    </div>
                </div>
                {/* Footer */}
                <div className="w-full bg-[#f7adc4] text-white text-center flex justify-center items-center px-4 py-2">
                    <img src="/1.png" alt="Logo" className="h-auto w-16 sm:w-20" />
                </div>
            </div>
        </div>
    );
};

export default Signup;
